<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>访客登记</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.visitorsname" @keyup.enter.native="clicksearch" placeholder="请输入访客姓名" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.receptionname" @keyup.enter.native="clicksearch" placeholder="请输入接待人姓名" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="Visitorstimein" label="访客入门时间" min-width="10%"></el-table-column>
          <el-table-column prop="Visitorstimeout" label="访客出门时间" min-width="10%"></el-table-column>
          <el-table-column prop="Visitorsname" label="访客姓名" min-width="5%"></el-table-column>
          <el-table-column prop="Visitorsdanwei" label="访客单位" min-width="5%"></el-table-column>
          <el-table-column prop="Visitorscard" label="访客证件号码" min-width="8%"></el-table-column>
          <el-table-column prop="Visitorsliyou" label="访客事由" min-width="10%"></el-table-column>
          <el-table-column prop="Receptionname" label="接待人姓名" min-width="7%"></el-table-column>
          <el-table-column prop="Registrationname" label="登记人姓名" min-width="7%"></el-table-column>
          <el-table-column prop="Beizhu" label="备注" min-width="10%"></el-table-column>
          <el-table-column prop="Createusername" label="谁录入睿云" min-width="7%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="10%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="6%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickdel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="添加访客登记" name="second">
      <el-form :model="addForm" ref="addFormRef" label-width="170px">
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">访客入门时间(必填)</span>
          </label>
          <el-date-picker v-model="addForm.visitorstimein" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item label="访客出门时间" class="addAdminForm">
          <el-date-picker v-model="addForm.visitorstimeout" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">访客姓名(必填)</span>
          </label>
          <el-input v-model="addForm.visitorsname"></el-input>
        </el-form-item>
        <el-form-item label="访客单位" class="addAdminForm">
          <el-input v-model="addForm.visitorsdanwei"></el-input>
        </el-form-item>
        <el-form-item label="访客证件号码" class="addAdminForm">
          <el-input v-model="addForm.visitorscard"></el-input>
        </el-form-item>
        <el-form-item label="访客事由" class="addAdminForm">
          <el-input v-model="addForm.visitorsliyou"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">接待人姓名(必填)</span>
          </label>
          <el-input v-model="addForm.receptionname"></el-input>
        </el-form-item>
        <el-form-item label="登记人姓名" class="addAdminForm">
          <el-input v-model="addForm.registrationname"></el-input>
        </el-form-item>
        <el-form-item label="备注" class="addAdminForm">
          <el-input v-model="addForm.beizhu"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickadd">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

  </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  name: 'MyShenPiBaoXiao',
  data () {
    return {
      activeName: 'first',
      addForm: {
        visitorstimein: '',
        visitorstimeout: '',
        visitorsname: '',
        visitorsdanwei: '',
        visitorscard: '',
        visitorsliyou: '',
        receptionname: '',
        registrationname: '',
        beizhu: ''
      },
      // 查询
      keywords: {
        visitorsname: '',
        receptionname: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1
    }
  },
  mounted () {
    this.apiGetVisitorslogNum()
    this.apiGetVisitorslogList()

    this.addForm.visitorstimein = Vue.prototype.FunGetTimeStringLong()
  },
  methods: {
    clickadd () {
      this.apiAddVisitorslog()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clickdel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelVisitorslog(row.Id)
      })
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetVisitorslogNum()
      this.apiGetVisitorslogList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetVisitorslogList()
    },
    apiGetVisitorslogNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        visitorsname: that.keywords.visitorsname,
        receptionname: that.keywords.receptionname
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetVisitorslogNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetVisitorslogList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        visitorsname: that.keywords.visitorsname,
        receptionname: that.keywords.receptionname
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetVisitorslogList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddVisitorslog: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        visitorstimein: that.addForm.visitorstimein,
        visitorstimeout: that.addForm.visitorstimeout,
        visitorsname: that.addForm.visitorsname,
        visitorsdanwei: that.addForm.visitorsdanwei,
        visitorscard: that.addForm.visitorscard,
        visitorsliyou: that.addForm.visitorsliyou,
        receptionname: that.addForm.receptionname,
        registrationname: that.addForm.registrationname,
        beizhu: that.addForm.beizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddVisitorslog, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetVisitorslogNum()
            that.apiGetVisitorslogList()

            // 清空添加
            that.addForm.visitorstimein = Vue.prototype.FunGetTimeStringLong()
            that.addForm.visitorstimeout = ''
            that.addForm.visitorsname = ''
            that.addForm.visitorsdanwei = ''
            that.addForm.visitorscard = ''
            that.addForm.visitorsliyou = ''
            that.addForm.receptionname = ''
            that.addForm.registrationname = ''
            that.addForm.beizhu = ''
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelVisitorslog: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        visitorslogid: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelVisitorslog, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetVisitorslogNum()
            that.apiGetVisitorslogList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
